import { FC, ComponentProps } from 'react';
import { StyleSheet, View } from '@react-pdf/renderer';
import theme from '../../Pdf/components/theme';
import PeriodEndReportPage from '../components/pdf/PeriodEndReportPage';
import SectionTitle from '../components/pdf/SectionTitle';
import FinancialStatementTitle from '../components/pdf/FinancialStatementTitle';
import { PeriodEndReportSectionPageProps } from '../types';
import PdfIncomeStatementTable from './PdfIncomeStatementTable';

const styles = StyleSheet.create({
  container: {
    paddingTop: theme.spacing(theme.spacingSizes.md),
  },
});

type Props = PeriodEndReportSectionPageProps &
  ComponentProps<typeof PdfIncomeStatementTable>;

const IncomeStatement: FC<Props> = ({
  firmLogoUrl,
  sectionNumber,
  pageNumber,
  totalPages,
  ...rest
}) => {
  return (
    <PeriodEndReportPage
      firmLogoUrl={firmLogoUrl}
      header={`0${sectionNumber} – Financial statements`}
      pageNumber={pageNumber}
      totalPages={totalPages}
    >
      <SectionTitle
        sectionNumber={sectionNumber}
        title="Financial statements"
      />
      <View style={styles.container}>
        <FinancialStatementTitle
          sectionNumber={sectionNumber}
          statementNumber={1}
          title="Income statement"
        />
      </View>
      <PdfIncomeStatementTable {...rest} />
    </PeriodEndReportPage>
  );
};

export default IncomeStatement;
